import { Check } from "lucide-react";
import { CLASSROOM_COLORS } from "../../config/classroomColors";
import "./classroom.css";

export default function ClassColorPicker({ value, onChange }) {
  return (
    <div className="class-color-field">
      <p className="class-color-hint">Logo colors only — each section can use any color.</p>
      <div className="class-color-picker" role="radiogroup" aria-label="Section color">
      {CLASSROOM_COLORS.map((color) => {
        const selected = value === color.value;
        return (
          <button
            key={color.value}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={color.label}
            className={`class-color-swatch ${color.tone}${selected ? " is-selected" : ""}`}
            onClick={() => onChange?.(color.value)}
          >
            {selected ? <Check size={14} /> : null}
          </button>
        );
      })}
      </div>
    </div>
  );
}
